exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme--light.v-btn[data-v-a5155210]:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){background-color:#00adbc!important}", ""]);

// exports
